import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getNumberConfigurationTypes() {
        return axios
            .get('/orders/orders/dicts/number-configuration-types')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy prefiksów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrderGraphicFileDeliveryMethods() {
        return axios
            .get('/orders/orders/dicts/order-graphic-file-delivery-method')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie metod dostarczania plików graficznych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createDeliveryAttachment(context, formData) {
        return axios
            .post('/orders/order/file/upload', formData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie planu dostaw nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addProductionFileAttachment({ commit, state }, { formData, abort}) {
        if (!abort) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', cancelTokenSource)
        } else {
            state.cancelToken.cancel('Canceled')
        }

        commit('FILE_PROGRESS', {
            show: true,
            value: 0
        }, { root: true })

        return axios
            .post('/orders/order-product/file/upload', formData, {
                cancelToken: state.cancelToken.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: false,
                        value: percentCompleted
                    }, { root: true })
                }
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie pliku produkcyjnego nie powiodło się.')

                return Promise.reject(error)
            })
            .finally(() => {
                commit('SET_CANCEL_TOKEN', null)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0
                }, { root: true })
            })
    },
    addProductionFileAttachmentLink(context, payload) {
        return axios
            .post('/orders/order-product/file/upload', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie linku do pliku produkcyjnego nie powiodło się.')
    
                return Promise.reject(error)
            })
    },
    deleteProductionFileAttachment(context, id) {
        return axios
            .delete(`/orders/order-product/file/upload/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie pliku produkcyjnego nie powiodło się.')

                return Promise.reject(error)
            })
    },
    temporarySaveOrderData({ commit }, { order, deliveryFile }) {
        commit('TEMPORARY_SAVE_ORDER_DATA', { order, deliveryFile })
    },
    updateOrderCreateProductList({ commit }, { product, productTemplate}) {
        commit('UPDATE_ORDER_CREATE_PRODUCT_LIST', { product, productTemplate })
    },
    updateOrderCreateProductTemplate({ commit }, { index, product, productTemplate }) {
        commit('UPDATE_ORDER_CREATE_PRODUCT_TEMPLATE', { index, product, productTemplate })
    },
    removeOrderCreateProductTemplate({ commit }, index) {
        commit('REMOVE_ORDER_CREATE_PRODUCT_TEMPLATE', index)
    },
    clearOrderCreate({ commit }) {
        commit('CLEAR_ORDER_CREATE')
    },
}
